import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../../shared/styles/vars';
import { media } from '../../../shared/styles/constants';

export const styles = StyleSheet.create({
    modal: {
        position: 'relative',
        top: '0',
        left: '0px',
        right: '0px',
        bottom: '0px',
        maxWidth: '1240px',
        margin: 'auto',
        outline: 'none',
        '-webkit-transform':'translateZ(0)',

        [media.LAPTOP]: {
            maxWidth: 1010,
        },

        [media.TABLET]: {
            maxWidth: 750
        },

        [media.MOBILE]: {
            maxWidth: 767,
            height: 'auto',
        }
    },

    overlay: {
        position: 'fixed',
        top: '111px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        backgroundColor: color.cobaltBlue,
        boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.3)',
        zIndex: 100001,
        height: 'auto',
        width: '100%',

        [media.AT_LEAST_TABLET]: {
            display: 'table'
        },
        [media.MOBILE]: { 
            overflowY: 'scroll',
            '-webkit-overflow-scrolling' : 'touch',
            height: '100%',
            top: '0px',
            zIndex: 100006,
            '::-webkit-scrollbar': { 
                display: 'none',
            }
        }
    },

    vmContainer: {
        width: '100%',
        display: 'inline-flex',
        height: '100%',
        paddingTop: '20px',

        [media.MOBILE]: {
            display: 'block',
            padding: '0',
        }
    },

    overlayBg: {
        position: 'fixed',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        zIndex: 999,
        opacity: '0.7',
        backgroundColor: '#1e242d'
    },

    vmHeader:{
        display: 'none',

        [media.MOBILE]: {
            display:'flex',
            alignItems: 'center',
            height: '45px',
            padding: '0 15px',
        }
    },

    hideMeta: {
        display: 'none',
    },

    closeButton: {
        position: 'absolute',
        width: '20px',
        height: '20px',
        right: 0,

        [media.MOBILE]: {
            right: '15px',
            top: '12px',
        },
    }, 

    vmContainer: {
        width: '100%',
        display: 'block',
        height: '100%',
        paddingTop: '20px',
        backgroundColor: color.cobaltBlue,

        [media.MOBILE]: {
            display: 'block',
            padding: '0',
        }
    },

    vmMoreVideos: {
        width: '100%',
        maxWidth: '340px',
        height: '100%',
        float: 'right',
        overflowY: 'auto',
        position: 'absolute',
        top: '20px',
        right: '10px',
        '::-webkit-scrollbar': { 
            display: 'none',
        },
        [media.TABLET]: {
            maxWidth: '285px',
        },
        [media.MOBILE]: {
            maxWidth: '100%',
            position: 'relative',
            top: '0px',
            right: '0px',
            display: 'block',
            float: 'none',
            '-webkit-overflow-scrolling': 'touch',
        }
    },

    vmMoreCont: {
        overflowY: 'scroll',
        '::-webkit-scrollbar': { 
            display: 'none',
        },

        [media.DESKTOP]:{
            height: 510,
        },
        [media.LAPTOP] : {
            height: 440,
        },
        [media.TABLET] : {
            height: 340
        },
        [media.MOBILE]: {
            maxHeight: 410
        },
        [media.SMALL]: {
            maxHeight: 275
        }
    },

});



// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/styles/VideoModalStyles.js